import { api } from '@services';

import { IPaginationResult } from '@models/Equipment.model';
import Manufacturer, {
  IManufacturer,
  IManufacturerApiModel,
} from '@models/Manufacturer.model';

export interface IFilterRequest {
  sort?: string;
  direction?: 'ASC' | 'DESC' | undefined;
}
export interface IPagination {
  page: number;
  limit: number;
  search?: string;
}
interface IRequest {
  pagination?: IPagination;
  filter?: IFilterRequest;
}

const indexManufacturersPagination = async ({
  pagination,
  filter,
}: IRequest): Promise<IPaginationResult<IManufacturer>> => {
  const { data: manufacturers } = await api.get<
    IPaginationResult<IManufacturerApiModel>
  >(
    `/manufacturers/index/?page=${pagination?.page || 1}&limit=${
      pagination?.limit || 20
    }${
      pagination?.search ? `&q=${encodeURIComponent(pagination.search)}` : ''
    }${filter?.sort ? `&sort=${filter.sort}` : ''}${
      filter?.direction ? `&direction=${filter.direction}` : ''
    }`,
  );

  return Manufacturer.arrayPaginatedFromApiModel(manufacturers);
};
export { indexManufacturersPagination };
